//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SyncRefresh",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    tooltipTitle: {
      type: String,
      default: ""
    },
    tooltipPlacement: {
      type: String,
      default: "right"
    }
  },
  computed: {
    title() {
      if (this.tooltipTitle) return this.tooltipTitle;
      return this.loading ? `${this.$t("global.words.refreshing")}...` : `${this.$t("global.words.refresh")}`;
    }
  },
  methods: {
    handleRefresh($event) {
      this.$emit("refresh", $event);
    }
  }
});